import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { SubscriptionDataResolver } from '@b2b/common/resolvers/subscription-data.resolver';
import { SubscriptionsDetailControllerModule } from './controllers/SubscriptionsDetailController';

export const SubscriptionsDetailView = angular
  .module('acme.view.application.subscriptions.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    SubscriptionsDetailControllerModule,
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.subscriptions.detail',
      url: '/:id/detail',
      views: {
        'subview-main': {
          controller: 'SubscriptionsDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/subscriptions/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Subscriptions Detail',
        permissions: ['SUBSCRIPTION_VIEW'],
        enablePreferences: true,
      },
      resolve: {
        SubscriptionData: SubscriptionDataResolver(),
      },
    });
  }).name;
